import React from "react";
import { useRenderTemplateWithCollections } from "../MacroBindingContext";

export interface MacroTextBlockProps {
  text: string;
}

const MacroTextBlock = {
  label: "Text",
  llmDescription: `A paragraph text block for email content.
- 'text' (string): The paragraph content to display
- Supports {{variable}} placeholders like {{FirstName}}, {{ProgramDaysText}}, {{QuoteLink}}
- Inside repeaters, also supports collection bindings like {{program.Name}}, {{room.RoomType}}, {{pos.Description}}
- Variables are substituted with actual values during preview and rendering
- Renders as a plain <p> element`,
  fields: {
    text: {
      type: "textarea" as const,
      label: "Text Content",
    },
  },
  defaultProps: {
    text: "Hi {{FirstName}},\n\nThank you for your inquiry!",
  },
  render: (props: MacroTextBlockProps) => {
    const render = useRenderTemplateWithCollections();
    const rendered = render(props.text);

    // Split by newlines and render as separate paragraphs or with <br>
    const lines = rendered.split("\n");

    return (
      <p>
        {lines.map((line, i) => (
          <React.Fragment key={i}>
            {line}
            {i < lines.length - 1 && <br />}
          </React.Fragment>
        ))}
      </p>
    );
  },
};

export default MacroTextBlock;
